module.exports = require("@open-rpc/client-js");